/**
 * # ⛓️ CURSOR_ANCHOR:ui:sticky-search-panel
 * Добавляет класс sticky-active при скролле для усиленной тени
 * 
 * Само прилипание управляется через CSS position: sticky
 */

(function() {
  'use strict';

  function init() {
    var container = document.getElementById('search-form');
    if (!container) {
      console.warn('[STICKY] #search-form not found');
      return;
    }

    var ticking = false;

    function updateStickyClass() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      
      if (scrollY > 10) {
        container.classList.add('sticky-active');
      } else {
        container.classList.remove('sticky-active');
      }
      
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyClass);
        ticking = true;
      }
    }, { passive: true });

    // Вызываем сразу при загрузке
    updateStickyClass();
    
    console.log('[STICKY] Initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
